import React from 'react';

import { Palette } from 'DesignSystem2/Theme';

import Icon, { IconName } from './Icon';

interface IconBadgeProps {
    iconName: IconName;
    color?: string;
    iconColor?: string;
}

const IconBadge = ({ iconName, color = Palette.Brand.Primary, iconColor = Palette.Text.x10 }: IconBadgeProps) => {
    const IconElement = Icon[iconName];

    return (
        <div
            className={'flex min-h-4 w-4 h-4 items-center justify-center p-0.5 rounded-x50 border-[4px] border-solid'}
            style={{
                borderColor: color,
                ...(iconColor && { color: iconColor }),
            }}
        >
            <IconElement size={28} />
        </div>
    );
};

export default IconBadge;
